// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC, useContext } from "react";
import { resultCountProps } from "@store/Themes/common/props/resultCount";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import { BackOrdersDataViewContext } from "@store/Framework/Store/Store/Data/BackOrders/BackOrdersSelectors";

export interface BackOrdersResultCountStyles {
    backOrderCountText?: TypographyPresentationProps;
}

export const resultCountStyles: BackOrdersResultCountStyles = {
    backOrderCountText: resultCountProps.countText,
};

const styles = resultCountStyles;

const BackOrdersResultCount: FC<WidgetProps> = () => {
    const backOrdersDataView = usePersistentDataView(useContext(BackOrdersDataViewContext));

    if (!backOrdersDataView.value || !backOrdersDataView.pagination) {
        return null;
    }

    const { totalItemCount } = backOrdersDataView.pagination;

    if (totalItemCount === 0) {
        return null;
    }

    return (
        <Typography {...styles.backOrderCountText}>
            {totalItemCount} {totalItemCount === 1 ? translate("Backorder") : translate("Backorders")}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: BackOrdersResultCount,
    definition: {
        group: "Order History",
        displayName: "Backorders Result Count",
        allowedContexts: ["BackOrdersPage"],
    },
};

export default widgetModule;
